import 'components/Admin/Spinner/Spinner.less';

const Spinner = () => (
    <div className="clickme-loader-wrapper">
        <div className="clickme-loader">
            <div className="clickme-loader__pond">
                <div className="clickme-loader__pond-water" />
            </div>
            <div className="clickme-loader-duck">
                <div className="clickme-loader-duck__head" />
            </div>
        </div>
    </div>
);

export default Spinner;
